import { render, staticRenderFns } from "./VueFileUpload.vue?vue&type=template&id=048e785c"
import script from "./VueFileUpload.vue?vue&type=script&lang=js"
export * from "./VueFileUpload.vue?vue&type=script&lang=js"
import style0 from "./VueFileUpload.vue?vue&type=style&index=0&id=048e785c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports